<template>
  <div class="daterange-dropdown">
    <el-dropdown @command="debounceChangeDate">
      <span class="el-dropdown-link">
        <i class="material-icons icon">calendar_today</i> {{ selectedDataRange.label }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(dateRange, idx) in dateRangeChoices"
          :key="idx"
          :command="dateRange.value"
          :class="{ 'display-none': selectedDataRange.value === dateRange.value }"
          :disabled="disableSelection"
        >
          <div class="box flex align-center gaps">
            <span class="box body1">{{ dateRange.label }}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { DATE_RANGE_CHOICES } from '@/constants/datetime.constants'

export default {
  name: 'DateRangeDropdown',
  props: {
    dateRangeOptions: {
      type: [Array, Object],
      default () {
        return {}
      }
    },
    storePrefConstant: { type: String, default: '' },
    dateRangeVal: { type: String, default: '' },
    disableSelection: { type: Boolean, default: false }
  },
  data () {
    return {
      debounceChangeDate: undefined,
      selected: _.isEmpty(this.dateRangeVal) ? this.dateRangeChoices[0].hours : this.dateRangeVal
    }
  },
  computed: {
    selectedDataRange () {
      return _.find(this.dateRangeChoices, { value: this.selected })
    },
    dateRangeChoices () {
      if (_.isEmpty(this.dateRangeOptions)) {
        return DATE_RANGE_CHOICES
      }
      return this.dateRangeOptions
    }
  },
  methods: {
    changeDate (newDate, event) {
      if (this.disableSelection) {
        return false
      }
      if (this.selectedDataRange.value === newDate) {
        return false
      }
      this.selected = newDate
      if (!_.isEmpty(this.storePrefConstant)) {
        this.$store.dispatch(this.storePrefConstant, newDate)
      }
    }
  },
  created () {
    this.debounceChangeDate = _.debounce((newDate, event) => {
      this.changeDate(newDate, event)
      this.$emit('date-selection-change', newDate)
    }, 250)
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/icon.css';

.daterange-dropdown {
  display: inline;
}

.icon {
  margin: 0px;
  background: white;
  font-size: 1.2em;
  vertical-align: text-bottom;
}

.body1 {
  margin: 5px 0px;
}

.el-dropdown {
  cursor: pointer;
  border: 1px solid var(--border-color);
  padding: 8px 7px 9px 7px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/dropdown/DateRangeDropdown.vue